import { render, staticRenderFns } from "./VueSwiper.vue?vue&type=template&id=0b71ac31&"
import script from "./VueSwiper.vue?vue&type=script&lang=js&"
export * from "./VueSwiper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports